import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getHoverStyle = (Control: StyledComponent, checked: boolean): SerializedStyles => css`
  &:hover {
    ${Control} {
      ${checked
        ? css`
            background-color: ${Color.Lavender600};
          `
        : css`
            background-color: ${Color.Grey700};
          `};
    }
  }
`
